module.exports = __webpack_public_path__ + "img/marker-point-purpura.ac95d8f2.png";